function extractBrowserInfoFromUserAgent(userAgent) {
    const ua = userAgent.toLowerCase();
    const match = /(ipad)/.exec(ua) ||
        /(edge)[ \/]([\w.]+)/.exec(ua) ||
        /(edg)[ \/]([\w.]+)/.exec(ua) ||
        /(chrome)[ \/]([\w.]+)/.exec(ua) ||
        /(webkit)[ \/]([\w.]+)/.exec(ua) ||
        /(opera)(?:.*version|)[ \/]([\w.]+)/.exec(ua) ||
        /(msie) ([\w.]+)/.exec(ua) ||
        /(trident).*? rv:([\w.]+)/.exec(ua) ||
        (ua.indexOf('compatible') < 0 && /(mozilla)(?:.*? rv:([\w.]+)|)/.exec(ua)) ||
        [];
    const versionMatch = ua.match(/version\/([\d.]+)/i);
    // Look for version in the form: "Version/X.x" i.e in Safari
    let version = versionMatch != null ? match[1] : null;
    if (version === 'webkit') {
        version = versionMatch != null ? versionMatch[1] : null;
    }
    return {
        browser: match[1] || '',
        version: version || match[2] || '0',
        userAgent,
    };
}
export function getBrowserInfo(userAgent = navigator.userAgent) {
    const browserInfo = extractBrowserInfoFromUserAgent(userAgent);
    if (browserInfo.browser === 'trident') {
        browserInfo.browser = 'msie';
    }
    return browserInfo;
}
// TODO: remove module state, use functions instead of compute-once-on-import values to enable unit testing
const browserInfo = getBrowserInfo();
export const ipod = Boolean(/(ipod)/.exec(navigator.userAgent.toLowerCase()));
export const ipad = browserInfo.browser === 'ipad' ? true : undefined;
export const safari = browserInfo.browser === 'webkit' || Boolean(ipad) ? true : undefined;
export const edge = browserInfo.browser === 'edge' || browserInfo.browser === 'edg';
export const mozilla = browserInfo.browser === 'mozilla' ? true : undefined;
export const iphone = Boolean(/(iphone)/.exec(navigator.userAgent.toLowerCase()));
export const windows = /win(16|nt|dows)/.test(navigator.userAgent.toLowerCase());
/**
 * Returns true if the browser is a supported mobile browser, false otherwise. This should be kept
 * in sync with `detect_mobile()` in metaserver/pylons_common/util.py
 *
 * NOTE: The Logic for 'googlebot-mobile' and 'microsoft office mobile' was put in place
 * to keep the logic symmetric to the server side implementation. However a cursory google search
 * did not return any known user agent strings that match these substrings.
 *
 * @param {string} userAgent - the user agent string of the client browser
 */
export function isSupportedMobileBrowser(userAgent = navigator.userAgent) {
    const ua = (userAgent || '').toLowerCase();
    return (ipod ||
        iphone ||
        ua.indexOf('tizen') !== -1 ||
        (ua.indexOf('android') !== -1 && ua.indexOf('mobile') !== -1) ||
        ua.indexOf('bb10') !== -1 ||
        ua.indexOf('netfront') !== -1 ||
        /windows phone|opera mini|blackberry|nokia/.test(ua) ||
        (ua.indexOf('firefox') !== -1 && ua.indexOf('mobile') !== -1) ||
        ua.indexOf('googlebot-mobile') !== -1 ||
        ua.indexOf('iemobile') !== -1 ||
        ua.indexOf('opera mobi') !== -1 ||
        /ucweb|ucbrowser/.test(ua) ||
        ua.indexOf('microsoft office mobile') !== -1);
}
/**
 * Returns true if the browser is an android browser, false otherwise. This should be kept
 * in sync with `is_android()` in metaserver/pylons_common/util.py*
 *
 * @param {string} userAgent - the user agent string of the client browser
 */
export function isAndroid(userAgent = navigator.userAgent) {
    const ua = (userAgent || '').toLowerCase();
    // NOTE: 'silk' is the kindle fire browser
    return ua.indexOf('android') !== -1 || ua.indexOf('silk') !== -1;
}
/**
 * Returns true if the browser is a tablet browser, false otherwise. This should be kept
 * in sync with `is_tablet()` in metaserver/pylons_common/util.py*
 *
 * @param {string} userAgent - the user agent string of the client browser
 */
export function isTablet(userAgent = navigator.userAgent) {
    return ipad || (isAndroid(userAgent) && !isSupportedMobileBrowser(userAgent));
}
/**
 * Returns true if the browser is a mobile or tablet browser, false otherwise.
 *
 * @param {string} userAgent - the user agent string of the client browser
 */
export function isMobileOrTablet(userAgent = navigator.userAgent) {
    return isSupportedMobileBrowser(userAgent) || isTablet(userAgent);
}
export const mac = Boolean(/(macintosh)/.exec(navigator.userAgent.toLowerCase()));
//# sourceMappingURL=browser_detection.preenvesnextjs.map
